import ProjectDetailFormContainer from './ProjectDetailFormContainer';
export default ProjectDetailFormContainer;